import { report } from 'helpers/reporter'
import React from 'react'

interface Props {
  fallback?: React.ReactNode | ((error: Error) => React.ReactNode)
  children?: React.ReactNode
}

interface DefaultState {
  hidden: false
  error: undefined
}

interface ErrorState {
  hidden: true
  error: Error
}

type State = DefaultState | ErrorState

class ErrorBoundary extends React.PureComponent<Props, State> {
  state = { hidden: false, error: undefined } as const
  componentDidCatch(error: Error, errorInfo: { componentStack: string }) {
    this.setState({
      hidden: true,
      error,
    })

    if (
      process.env.NODE_ENV !== 'production' &&
      process.env.NODE_ENV !== 'test'
    ) {
      console.error(error)
    }

    report(error, errorInfo)
  }

  render() {
    if (this.state.hidden) {
      if (!this.props.fallback) {
        return null
      }
      if (typeof this.props.fallback === 'function') {
        return this.props.fallback(this.state.error!)
      }
      return this.props.fallback || null
    }
    return this.props.children
  }
}

export default ErrorBoundary
